/** Bank statement rule condition comparison types */
export enum BankStatementRuleConditionTypeEnum {
  /** Value is equal (`=`) */
  EQUAL = 'EQUAL',
  /** Value is bigger than (`>`) */
  BIGGER_THAN = 'BIGGER_THAN',
  /** Value is lower than (`<`) */
  LOWER_THAN = 'LOWER_THAN',
}
